var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1508 12.4216C31.7046 12.4216 31.342 12.0603 31.342 11.6128V7.39143L32.9583 7.11267V11.614C32.9596 12.0578 32.5971 12.4216 32.1508 12.4216Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8092 0L9.62769 5.62764L12.694 6.17265C13.0953 5.8939 13.5828 5.73014 14.1078 5.73014H27.5081C28.0331 5.73014 28.5207 5.8939 28.9219 6.17265L32.0057 5.63889L20.8092 0Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1104 7.34646C13.6317 7.34646 13.2429 7.73522 13.2429 8.21274V10.7553H28.3783V8.21274C28.3783 7.99773 28.2995 7.79898 28.1695 7.64897C28.1358 7.62022 28.1045 7.58897 28.0745 7.55397C27.9233 7.42397 27.727 7.34521 27.512 7.34521L14.1104 7.34646Z",
    fill: "#747474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1992 12.3704V14.8392C13.2355 16.8618 14.053 18.7481 15.503 20.1518C15.9055 20.5406 16.3405 20.8794 16.8056 21.1644H16.8193C17.1093 21.1644 17.3643 21.3169 17.5056 21.5456C18.5469 22.0444 19.6969 22.2969 20.8869 22.2756C21.9869 22.2556 23.0457 22.0069 24.0095 21.5494C24.1507 21.3181 24.407 21.1631 24.7008 21.1631H24.722C25.2583 20.8331 25.757 20.4343 26.2058 19.9706C27.6121 18.5168 28.3671 16.6067 28.3333 14.5879C28.3321 14.5829 28.3321 14.5792 28.3321 14.5742V12.3691L13.1992 12.3704Z",
    fill: "#747474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7655 34.6909C22.7718 34.6909 24.4056 36.3247 24.4056 38.3322C24.4056 40.341 22.7718 41.9736 20.7655 41.9736C18.7567 41.9736 17.1242 40.3398 17.1242 38.3322C17.1242 36.3222 18.7567 34.6909 20.7655 34.6909ZM19.023 30.707H6.03763H5.37012L6.7539 45.9537H34.7784L36.1621 30.707H35.4834H22.5055H19.023Z",
    fill: "#747474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7655 36.3058C19.648 36.3058 18.7405 37.2146 18.7405 38.3308C18.7405 39.4471 19.648 40.3559 20.7655 40.3559C21.8818 40.3559 22.7893 39.4471 22.7893 38.3308C22.7893 37.2146 21.8818 36.3058 20.7655 36.3058Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1183 26.9907L23.907 29.0908H33.4797C32.6897 28.5295 31.7784 28.1458 30.8022 27.9745L25.1183 26.9907Z",
    fill: "#747474"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6267 23.3492V25.8806L19.4868 29.0894H22.0393L23.8894 25.8806V23.3492C22.9468 23.6893 21.9431 23.8755 20.913 23.8943C20.8593 23.8955 20.8068 23.8955 20.753 23.8955C19.6705 23.8955 18.6167 23.7093 17.6267 23.3492Z",
    fill: "#747474"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4043 26.9932L10.7304 27.9757C9.75164 28.1407 8.83286 28.5245 8.03784 29.092H17.6218L16.4043 26.9932Z",
    fill: "#747474"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3273 47.5699H1.21386C0.881356 47.5699 0.571349 47.6975 0.341343 47.93C0.117588 48.1562 -0.00366564 48.4575 8.44529e-05 48.7775C8.44529e-05 49.4562 0.545098 50 1.21511 50H40.3261C40.9961 50 41.5411 49.455 41.5411 48.785C41.5424 48.1162 40.9974 47.5699 40.3273 47.5699Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.af8f3ab37703e052785ee5b84884de1f.svg";
export { ForwardRef as ReactComponent };